import IconBlock from './IconBlock';

(() => {
    /**
     * Initialise any/all components on the page.
     *
     * Note: We assume there may be more than one
     * instance of this component on the page.
     */
    const componentNodeList = document.querySelectorAll('.icon-block__container');

    componentNodeList.forEach((component) => {
        // Instantiate the IconBlock class, but don't really do anything with it
        const IconBlockInstance = new IconBlock(component as HTMLElement);
    });
})();
